import { render, staticRenderFns } from "./proModel.vue?vue&type=template&id=bbadce68&scoped=true&"
import script from "./proModel.vue?vue&type=script&lang=js&"
export * from "./proModel.vue?vue&type=script&lang=js&"
import style0 from "./proModel.vue?vue&type=style&index=0&id=bbadce68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbadce68",
  null
  
)

export default component.exports